import { useEffect, useRef, useState } from "react";
import "./message.sass";

const messageTypes = {
  SUCCESS: "success",
  DANGER: "danger",
  WARNING: "warning",
};

export const MessageBox = ({ show, close, messageType, messageText }) => {
  if (!show) {
    return <></>;
  }
  return <Message close={() => close()} messageType={messageType} messageText={messageText} />;
};

const Message = ({ close, messageType, messageText }) => {
  const [closingMessage, setClossingMessage] = useState();
  const timeoutRef = useRef(null);

  const closeMessage = () => {
    setClossingMessage(true);
    setTimeout(() => close(), 350);
  };

  const startTimer = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      closeMessage();
    }, 10000);
  };

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
  };

  const handleMouseLeave = () => {
    startTimer();
  };

  useEffect(() => {
    startTimer();
  }, []);

  return (
    <div
      className={`message ${messageType ? messageType : ""}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        animation: `messageIn 1s cubic-bezier(0.4, 0.2, 0, 1) forwards${
          closingMessage ? ",messageOut 1s cubic-bezier(0.4, 0.2, 0, 1) forwards" : ""
        }`,
        transition: `all 350ms cubic-bezier(0.4,0.2,0,1)`,
        pointerEvents: "auto",
        transform: `translateY(-${20 + 55}px) scale(${1})`,
        opacity: 1,
      }}
    >
      <span className={"status-dot"} />
      <div className={`text`}>{messageText}</div>
      <div className="icon-container" onClick={() => closeMessage()}>
        <span className={"material-symbols-outlined"}>close</span>
      </div>
    </div>
  );
};
